export default "__VITE_ASSET__CqNVfuZx__"